import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppNavProgressService } from 'app/services/navigation/app-nav-progress.service';

/**
 * Compte les requêtes HTTP de chargement initial d'une page ERP (hors paramétrage) afin de
 * synchroniser la barre de progression globale avec les données réellement chargées.
 */
@Injectable()
export class AppNavHttpInterceptor implements HttpInterceptor {
  private static readonly TRACK_METHODS = new Set(['GET', 'POST', 'PUT', 'PATCH']);

  constructor(private readonly appNav: AppNavProgressService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.appNav.shouldTrackHttpRequest()) {
      return next.handle(request);
    }
    if (!AppNavHttpInterceptor.TRACK_METHODS.has(request.method)) {
      return next.handle(request);
    }

    this.appNav.beginPageDataLoad();
    return next.handle(request).pipe(finalize(() => this.appNav.endPageDataLoad()));
  }
}
